import { plural } from '@cian/utils';
import { createSelector } from '@reduxjs/toolkit';
import { selectBedrooms } from 'shared/selectors/jsonQuery';

export const selectBedroomsLabel = createSelector(selectBedrooms, bedrooms => {
  const { gte: min = null, lte: max = null } = bedrooms || {};

  if (min !== null && max === null) {
    return `от ${min} ${plural(min, ['спальни', 'спален', 'спален'])}`;
  }

  if (min === null && max !== null) {
    return `до ${max} ${plural(max, ['спальни', 'спален', 'спален'])}`;
  }

  if (min !== null && max !== null) {
    return `${min} - ${max} спален`;
  }

  return 'Спальни';
});
